export default __webpack_public_path__ + "static/media/Tracking_B_Triangle.9dff7981.svg";